import { render, staticRenderFns } from "./SplitPanelB.vue?vue&type=template&id=6907247d&scoped=true&"
import script from "./SplitPanelB.vue?vue&type=script&lang=js&"
export * from "./SplitPanelB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6907247d",
  null
  
)

export default component.exports